export const OPEN_DROPDOWN_EVENT = 'eag-open-dropdown' as const;
